import React from "react";
import {
  Checkbox,
  Link,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { HoursDto } from "../hours.dtos";
import { Paper } from "@material-ui/core";
import { Table } from "@material-ui/core";
import moment from "moment";
import { DenseTableCell } from "../../../../../../common/styles/styles";

interface IProps {
  hours: HoursDto[];
  editDay: (value: HoursDto, museum: number) => void;
}

const HoursTable: React.FC<IProps> = ({ hours, editDay }) => {
  const columnNames = ["Day of", "Open", "Close", "Closed All Day", "Active"];

  return (
    <TableContainer component={Paper}>
      <Table aria-label="hours table">
        <TableHead>
          <TableRow>
            {columnNames.map((c, i) => (
              <DenseTableCell key={i} align="center">
                {c}
              </DenseTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {hours.length > 0 ? (
            hours.map((h, i) => (
              <TableRow key={i}>
                <DenseTableCell component="th" scope="row">
                  <Link onClick={() => editDay(h, h.museumId)}>{h.day}</Link>
                </DenseTableCell>
                <DenseTableCell align="center">
                  {h.open && moment.utc(h.open).format("hh:mm A")}
                </DenseTableCell>

                <DenseTableCell align="center">
                  {h.close && moment.utc(h.close).format("hh:mm A")}
                </DenseTableCell>
                <DenseTableCell align="center">
                  <Checkbox
                    name="closedAllDay"
                    color="primary"
                    checked={h.closedAllDay}
                    inputProps={{ readOnly: true }}
                  />
                </DenseTableCell>
                <DenseTableCell align="center">
                  <Checkbox
                    name="isActive"
                    color="primary"
                    checked={h.isActive}
                    inputProps={{ readOnly: true }}
                  />
                </DenseTableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <DenseTableCell align="center" colSpan={columnNames.length}>
                No data
              </DenseTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HoursTable;
